import { toast } from 'react-toastify';

export default function OrderSummary({ 
     items, 
    total, 
    onPlaceOrder,
    businessName,
    salePointName,
    customerInfo,
    paymentType,
    cartItems
}) {
    const handlePlaceOrder = async () => {
        if (!customerInfo ||
            !customerInfo.custName?.trim() ||
            !customerInfo.address?.trim() ||
            !customerInfo.state ||
            !customerInfo.district ||
            !paymentType) {
            toast.error("يرجى تعبئة جميع الحقول المطلوبة، بما في ذلك نوع الدفع.");
            return;
        }

        try {
            const payload = {
                custName: customerInfo.custName,
                hp1: customerInfo.phoneNumber,
                hp2: "",
                address: customerInfo.address,
                state: customerInfo.state,
                district: customerInfo.district,
                items: cartItems.map(item => ({
                    itemId: item.item_id ?? item.id,
                    qty: item.quantity ?? item.qty,
                    price: item.price ?? item.unitPrice,
                    combinationId: item.combinationId ?? null
                }))
            };

            const res = await fetch(`/api/orders/${businessName}/${salePointName}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (!res.ok) {
                let message = "تعذر إتمام الطلب, يرجى المحاولة لاحقاً";
                try {
                    const errData = await res.json();
                    if (errData?.message) message = errData.message;
                } catch (_) {
                    // body wasn't JSON — fall back to the generic message
                }
                toast.error(message);
                return; // stop here — don't clear the cart / navigate away on failure
            }

            toast.success("تم إتمام الطلب بنجاح! شكرًا لكم");
            onPlaceOrder();
        } catch (err) {
            console.error('خطأ في تقديم الطلب', err);
            toast.error("تعذر الاتصال بالخادم, يرجى التحقق من الاتصال والمحاولة لاحقاً");
        }
    };

    return (
        <>
            {items?.length > 0 ? (
                <>
                    <ul className="order-items-list">
                        {items.map((item, idx) => (
                            <li key={idx} className="order-item-card">
                                <img
                                    src={item.image1Url}
                                    alt={item.productNameEn}
                                    className="order-item-image"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        // e.target.src = '/path/to/placeholder-image.png';
                                    }}
                                />
                                <div className="order-item-details">
                                    <strong>{item.productNameEn}</strong> × {item.quantity}
                                    {item.combinationText && (
                                        <>
                                            <br />
                                            <span className="cart-variant-text">{item.combinationText}</span>
                                        </>
                                    )}
                                    <br />
                                    <span className="order-item-price">
                                        = IQD {(item.price * item.quantity).toFixed(2)}
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className="order-summary">
                        <h2 className="order-total">
                            إجمالى الطلب: {total.toFixed(2)} IQD
                        </h2>
                        <button 
                            onClick={handlePlaceOrder} 
                            className="place-order-button"
                        >
                            تنفيذ الطلب
                        </button>
                    </div>
                </>
            ) : (
                <p className="empty-order-message">لا يوجد عناصر او مواد في الطلب</p>
            )}
        </>
    );
}